/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { WhatIfSimulationHttpService } from "./http/what-if-simulation-http.service";

@Injectable({
	providedIn: "root"
})
export class WhatIfSimulationService {
	constructor(private _whatIfSimulationHttpService: WhatIfSimulationHttpService) {}

	/**
	 * Runs a simulation for a given scenario and tenant.
	 *
	 * @param {number} scenarioId - The ID of the scenario to run the simulation for.
	 * @param {string} tenantId - The ID of the tenant for which the simulation is run.
	 * @returns An observable containing a message indicating the result of the simulation.
	 */
	public runSimulation(scenarioId: number, tenantId: string): Observable<string> {
		return this._whatIfSimulationHttpService.runSimulation(scenarioId, tenantId);
	}
}
